(function () {
    'use strict';

    angular
        .module('homeMyTasksControllers')
        .controller('MyTasksController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        $scope.tasksCountByName = {};
        $scope.pendingsReviewCountByName = {};
        $scope.pendingsReviewGovernanceProcessByName = {};

        // Get Tasks Total Count
        $scope.getTasksTotalCount = function () {
            return _.reduce($scope.tasksCountByName, function (total, taskCount) {
                return total + taskCount;
            });
        };

        // With Tasks
        $scope.withTasks = function () {
            return $scope.getTasksTotalCount() > 0;
        };

        // Get Pending Reviews Total Count
        $scope.getPendingReviewsTotalCount = function () {
            return _.reduce($scope.pendingsReviewCountByName, function (total, taskCount) {
                return total + taskCount;
            });
        };

        // With Pending Reviews
        $scope.withPendingReviews = function () {
            return $scope.getPendingReviewsTotalCount() > 0;
        };
    }
})();